import { Heading, Modal, useModal } from '@frontendmentorio/design-system-v2';

import Badge from 'features/badges/Badge';

export default function ProfileBadge({ achievement: { badge, count }, user }) {
  const modal = useModal();

  return (
    <>
      <button
        aria-label={`Learn more about the ${badge.title} badge`}
        onClick={modal.open}
      >
        <Badge count={count} name={user.displayName} slug={badge.slug} />
      </button>

      <Modal className="gap-6 text-center" modal={modal}>
        <Modal.Heading>{badge.title}</Modal.Heading>

        <div className="flex flex-col gap-4 items-center">
          <Badge className="w-[12rem]" slug={badge.slug} />

          <p>{badge.description}</p>
        </div>

        {badge.fact && (
          <div className="flex flex-col gap-2">
            <Heading level="2">Fun fact</Heading>

            <p className="text-sm">{badge.fact}</p>
          </div>
        )}
      </Modal>
    </>
  );
}
